import PageComponent from '@/components/index/index';
import { withKeepAlive } from 'react-next-keep-alive';
// export default PageComponent
export default withKeepAlive(PageComponent, 'Index');
